import { Star } from 'lucide-react';

// Fotos de mujeres
const FEMALE_AVATARS = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&h=100&fit=crop&crop=face",
];

// Fotos de hombres
const MALE_AVATARS = [
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1552058544-f2b08422138a?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1463453091185-61582044d556?w=100&h=100&fit=crop&crop=face",
];

// Nombres femeninos comunes
const FEMALE_NAMES = ['maría', 'maria', 'ana', 'laura', 'carmen', 'sophie', 'isabella', 'rosa', 'elena', 'lucia', 'claudia', 'patricia', 'sandra', 'andrea', 'paula', 'diana', 'silvia', 'monica', 'carolina', 'valentina', 'gabriela', 'fernanda', 'daniela', 'camila', 'alejandra'];

const getAvatarForName = (name, index) => {
  const firstName = name.toLowerCase().split(' ')[0];
  const isFemale = FEMALE_NAMES.some(fn => firstName.includes(fn) || fn.includes(firstName));
  
  if (isFemale) {
    return FEMALE_AVATARS[index % FEMALE_AVATARS.length];
  } else {
    return MALE_AVATARS[index % MALE_AVATARS.length];
  }
};

export const ReviewCard = ({ review, index = 0 }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < rating ? 'fill-amber-400 text-amber-400' : 'text-stone-200'}`}
      />
    ));
  };

  const avatarImage = getAvatarForName(review.name, index);

  return (
    <div 
      className="review-card bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-100"
      data-testid="review-card"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          {/* Avatar */}
          <img 
            src={avatarImage}
            alt={review.name}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <h4 className="font-semibold text-stone-900">{review.name}</h4>
            <p className="text-sm text-stone-500">{review.country}</p>
          </div>
        </div>
        <span className="text-xs text-stone-400 bg-stone-50 px-2 py-1 rounded-full">
          {review.date}
        </span>
      </div>

      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {renderStars(review.rating)}
      </div>

      {/* Comment */}
      <p className="text-stone-600 leading-relaxed">
        {review.comment}
      </p>
    </div>
  );
};

export default ReviewCard;
